export const changeSpanToImage = () => {
  const title = document.querySelector('.products-section__title');

  if (!title) return;

  const span = title.querySelector('span');

  if (!span) return;

  const img = document.createElement('img');
  img.src = `${themeUrl}/src/img/sirema-dark.svg`; // podaj ścieżkę do obrazka
  img.alt = 'Sirema';
  img.classList.add('inline-logo');

  span.replaceWith(img); 
};